import React, { Fragment } from 'react'
import { CircularProgress, LinearProgress } from '@mui/material';

export const default_loading_mess = "chargement en cours..."

/**
 * displays a loader element with some info JSX above if it's not empty
 * 
 * props: 
 * 		- mess (string/JSX) message to display above loader
 */
export function LoaderWithMess(props) {
	return (
		<Fragment>
			{props.mess ?
				<Fragment>
					{props.mess} <br /><br />
				</Fragment>
				: null}
			<Loader />
		</Fragment>
	)
}

/**
 * displays a loader visual with a loading message
 * 
 * props:
 * 	- text 	(string)	specify a different message, otherwise it will display the default one 
 * 	- inline			loader icon inline with loading message
 *  - small				no message, only a loader icon
 *  - linearIcon		use a linear loader icon
 *	- noMess			remove message
 *  - black				black loader, otherwise default color is white
*/
export function Loader(props) {

	var loading_mess = default_loading_mess

	if (props.text) {
		loading_mess = props.text
	}

	// const jsx_loaderICon = <i className="reloadIcon fas fa-sync fa-spin" />
	// const jsx_loaderICon = <i className="reloadIcon fas fa-circle-notch fa-spin" />
	let jsx_loaderIcon_small = <CircularProgress sx={{
		width: "18px !important", // force smaller
		height: "18px !important",
		color: (props.black ? "black" : "white"),
	}} />

	let jsx_loaderIcon = <CircularProgress sx={{
		color: (props.black ? "black" : "white"),
	}} />

	if (props.linearIcon) {
		jsx_loaderIcon = <LinearProgress sx={{ width: "100%", color: "white" }} />
		jsx_loaderIcon_small = jsx_loaderIcon
	}

	if (props.noMess || props.small) {
		return (
			<span style={{ display: "inline-flex", width: (props.linearIcon ? "100%" : "auto") }}>
				{props.small ?
					jsx_loaderIcon_small
					: jsx_loaderIcon}
			</span>
		)
	}

	if (props.inline) {
		return (
			<span style={{ display: "inline-flex", width: "100%" }}>
				{loading_mess} &nbsp;&nbsp;
				{jsx_loaderIcon}
			</span>
		)
	}

	return (
		<span style={{ display: "block", textAlign: "center" }}>
			{loading_mess} <br /><br />
			{jsx_loaderIcon}
		</span>
	)
}
